export function checkMinLength(str, length = 2) {
    if ((str.length >= length &&
        str.trim().length > 1) || str.length === 0 ) {
        return true
    } else {
        return `Min length is ${length}`
    }
}

export function checkMaxLength(str, length = 50) {
    if ((str.length <= length &&
        str.trim().length > 0) || str.trim().length === 0) {
        return true
    } else {
        return `Max length is ${length}`
    }
}